import { Account } from '@mitel/cloudlink-sdk';
import { PlatformEmbedded } from '../interfaces/collections';
import { Application, Platform, Tag, Processor } from './../interfaces/system-manager';
import { Util } from './Util';
import { CellType } from '../constants/constants';

export class SystemManagerUtil {
  static processPlatformsData(platformsEmbedded: PlatformEmbedded[]): Platform[] {
    if (platformsEmbedded?.length > 0) {
      return platformsEmbedded.map(platformEmbedded => {
        const tags = (platformEmbedded?._embedded?.tags?._embedded?.items || []).map(tag => {
          let value = tag.value ? Util.parseValueAsJson(tag.value) : '';
          return {
            tagId: tag.tagId ?? '',
            parentId: tag.parentId ?? '',
            parentType: tag.parentType ?? '',
            value: value,
            type: value == tag.value ? CellType.STRING : CellType.JSON
          }
        });

        const platform = {
          account: {} as Account,
          parentId: platformEmbedded.parentId ?? '',
          platformId: platformEmbedded.platformId ?? '',
          platformName: platformEmbedded.name ?? '',
          platformType: platformEmbedded.platformType ?? '',
          host: platformEmbedded.host ?? '',
          version: platformEmbedded.version ?? '',
          systemFamily: platformEmbedded.systemFamily ?? '',
          createdOn: platformEmbedded.createdOn ?? '',
          createdBy: platformEmbedded.createdBy ?? '',
          modifiedOn: platformEmbedded.modifiedOn ?? '',
          modifiedBy: platformEmbedded.modifiedBy ?? '',
          processor: {} as Processor,
          partitions: [],
          installedSoftware: [],
          applications: (platformEmbedded._embedded?.components?._embedded?.items || []).map(component => {
            return {
              applicationId: component.componentId,
              applicationType: component.componentType,
              applicationName: component.name ?? platformEmbedded.name ?? '', // component name might no be populated,
              ipAddress: this.getIPAddressStoredInTags(tags)
            } as Application
          }) ?? [],
          services: [],
          tags: tags,
          selected: false
        };
        return platform;
      });
    } else {
      return [];
    }
  }

  static getIPAddressStoredInTags(tags: Tag[]): string {
    // TO DO: double check criteria to find correct IP Address
    return tags?.find(tag => tag.tagId === 'machine' && tag.value?.networkInterfaces?.length >= 0)?.value['networkInterfaces']?.
      find(networkInterface => networkInterface?.flags?.indexOf('up|broadcast|multicast|running') > -1 && networkInterface?.addresses?.length >= 0)?.addresses[0]?.cidr ?? '';
  }
}